const CardDivider = () => <div className="card-divider"></div>;

export default CardDivider;
